const state = {
  version: null,
  nextUpdateIn: 0,
};

const mutations = {
  // eslint-disable-next-line no-shadow
  setVersion(state, { version, nextUpdateAt }) {
    state.version = version;
    state.nextUpdateIn = Math.max(
      0,
      nextUpdateAt - Math.floor(Date.now() / 1000)
    );
  },
  // eslint-disable-next-line no-shadow
  tick(state) {
    if (state.nextUpdateIn > 0) {
      // eslint-disable-next-line no-plusplus
      state.nextUpdateIn--;
    }
  },
};

const actions = {
  startTimers({ commit }) {
    setInterval(() => commit('tick'), 1000);
  },
};

export default { namespaced: true, state, mutations, actions };
